import { useEffect, useState } from 'react'
import i18n from '../../i18n'

type langAttrOptions = {
    [key: string]: string
}
const langAttrs: langAttrOptions = {
    eng: "en",
    est: "et",
    ru: "ru",
    ukr: "uk",
}

export function useLangSelect(lang = 'ENG') {
    const [langSelect, setLang] = useState<string>(lang)
    useEffect(() => {
        if (langSelect != i18n.language){
            const langSel = langSelect.toLowerCase()
            i18n.changeLanguage(langSel)
            document.documentElement.lang = langAttrs[langSel];
        }
    }, [langSelect])

    useEffect(() => {
        setLang(i18n.language.toUpperCase())
    }, [i18n.language])

    return [langSelect, setLang] as const
}